<template>
  <div class="b-card">
    <div class="b-card-title">Beställning av betongbrunn</div>

    <div class="form-group">
      <label for="date">Datum *</label>
      <input id="date" v-model="common.date" type="date" required onclick="this.showPicker()" />
    </div>
    <div class="form-group">
      <label for="place">Arbetsplats/Märkning *</label>
      <input
        id="place"
        v-model="common.place"
        type="text"
        required
        maxlength="50"
        :class="{ 'input-error': errors['common.place'] }"
        @blur="store.validateField('common.place', common.place)"
      />
    </div>
    <div class="form-group">
      <label for="customerName">Kund *</label>
      <input
        id="customerName"
        v-model="customer.firstName"
        type="text"
        required
        maxlength="50"
        :class="{ 'input-error': errors['customer.firstName'] }"
        @blur="store.validateField('customer.firstName', customer.firstName)"
      />
    </div>
    <div class="form-group">
      <label for="customerNumber">Kundnummer</label>
      <input id="customerNumber" v-model="customer.number" type="text" maxlength="50" />
    </div>
    <div class="form-group">
      <label for="phone">Telefonnummer *</label>
      <input
        id="phone"
        v-digits:phone
        v-model="customer.phone"
        type="tel"
        required
        maxlength="50"
        :class="{ 'input-error': errors['customer.phone'] }"
        @blur="store.validateField('customer.phone', customer.phone)"
      />
    </div>
    <div class="form-group">
      <label for="ref">Kundens referens *</label>
      <input
        id="ref"
        v-model="customer.lastName"
        type="text"
        required
        maxlength="50"
        :class="{ 'input-error': errors['customer.lastName'] }"
        @blur="store.validateField('customer.lastName', customer.lastName)"
      />
    </div>
    <div class="form-group">
      <label for="deliveryDate">Önskat leveransdatum *</label>
      <input
        id="deliveryDate"
        v-model="customer.deliveryDate"
        type="date"
        required
        :min="today"
        :class="{ 'input-error': errors['customer.deliveryDate'] }"
        @blur="store.validateField('customer.deliveryDate', customer.deliveryDate)"
        @change="store.validateField('customer.deliveryDate', customer.deliveryDate)"
        onclick="this.showPicker()"
      />
      <p v-if="isWeekend(customer.deliveryDate)" class="field-error">
        Leverans sker på vardagar – välj måndag–fredag.
      </p>
    </div>
    <div class="form-group form-group--top">
      <label for="information">Övrig information</label>
      <textarea id="information" v-model="customer.information" rows="2" maxlength="150"></textarea>
      <p class="field-hint">{{ (customer.information || '').length }}/150 tecken</p>
    </div>
  </div>
</template>

<script>
import { store, isWeekend } from '@/store.js'

export default {
  name: 'StepCustomer',
  data() {
    return { store }
  },
  methods: { isWeekend },
  computed: {
    customer() {
      return this.store.customer
    },
    common() {
      return this.store.common
    },
    errors() {
      return this.store.validationErrors
    },
    today() {
      return new Date().toISOString().split('T')[0]
    },
  },
}
</script>
